import React from 'react';



import { sectionsMessages } from '../../../../translates/sectionsMessages';
import { MenuContentItem } from './MenuContentItem';
import { MenuContentWrapper } from './MenuContentWrapper';
import { SectionMenuContentItem, TrackingStatusEnum } from '@ael/core-api';
import classNames from 'classnames';
import { List } from 'immutable';
import { FormattedMessage } from 'react-intl';



import './MenuSplitItem.scss';


interface MenuSplitItemProps {
  sections: List<SectionMenuContentItem>;
  onClick?: (contentItemId: string) => void;
}

export const MenuSplitItem: React.FunctionComponent<MenuSplitItemProps> = ({ sections, onClick }) => {
  const isActive = sections.some((section: SectionMenuContentItem) => section.isActive);
  const isInProgress = sections.some(
    (section: SectionMenuContentItem) =>
      section.trackingStatus === TrackingStatusEnum.InProgress ||
      section.trackingStatus === TrackingStatusEnum.Completed
  );
  const isCompleted = sections.every(
    (section: SectionMenuContentItem) => section.trackingStatus === TrackingStatusEnum.Completed
  );
  const firstSection = sections.first();
  return (
    <div className="menu-split-item">
      <div
        className={classNames('menu-split-item__choose-one', {
          'menu-split-item__choose-one--in-progress': isInProgress,
          'menu-split-item__choose-one--completed': isCompleted,
        })}
      >
        <div
          className={classNames('menu-split-item__choose-one-indicator', {
            'menu-split-item__choose-one-indicator--active': isActive,
            'menu-split-item__choose-one-indicator--in-progress': isInProgress,
            'menu-split-item__choose-one-indicator--completed': isCompleted,
          })}
        />
        <div
          onClick={onClick && firstSection ? () => onClick(firstSection.itemId) : undefined}
          className="menu-split-item__choose-one-title"
        >
          <FormattedMessage {...sectionsMessages.chooseOne} />
        </div>
      </div>
      <div className="menu-split-item__sections-wrapper">
        {sections.map((section: SectionMenuContentItem) => {
          const firstSectionChildItem = section.childItems.first();
          return (
            <div className="menu-split-item__section" key={section.itemId}>
              <MenuContentItem
                key={section.itemId}
                item={section}
                onClick={onClick && firstSectionChildItem ? () => onClick(firstSectionChildItem.itemId) : undefined}
              />
              <MenuContentWrapper
                contentItems={section.childItems}
                active={section.isExpanded}
                isGrandChild
                onContentItemClick={onClick}
                nestedLevel={0}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
